module.exports = __webpack_public_path__ + "static/Tim Mitra.e124dc3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Tim Mitra.jpg
// module id = 1242
// module chunks = 6166952557895